import { useBlocker } from 'react-router-dom';
import { useState } from 'react';

export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const useFormHook = () => {
	const [isDirty, setIsDirty] = useState(false);
	const [showDirtyModal, setShowDirtyModal] = useState(false);
	const [showSuccessModal, setShowSuccessModal] = useState(false);
	const [isSubmitting, setIsSubmitting] = useState(false);

	const validateFirstName = (value: string): string => {
		if (isInvalidString(value)) {
			return 'First Name is required';
		}
		return '';
	};

	const validateLastName = (value: string): string => {
		if (isInvalidString(value)) {
			return 'Last Name is required';
		}
		return '';
	};

	const validateEmail = (value: string): string => {
		if (isInvalidString(value)) {
			return 'Email is required';
		}
		if (!emailRegex.test(value)) {
			return 'Invalid email format';
		}
		return '';
	};

	const validatePhoneNumber = (value: string): string => {
		const nonDigitRegex = /\D/g;
		if (nonDigitRegex.test(value)) return 'Phone Number must contain only digits';
		if (value.length === 0) return ''; // Optional field
		if (value.length !== 10) return 'Phone Number must be 10 digits';
		return '';
	};

	const validateAccountId = (
		value: { label: string; value: string },
		otherValues: string[]
	): string => {
		if (isInvalidString(value.value)) {
			return 'Account is required';
		}
		if (!validateDuplicatesDontExist(value.value, otherValues)) {
			return 'Duplicate accounts are not allowed';
		}
		return '';
	};

	const validateRoleId = (value: string): string => {
		if (isInvalidString(value)) {
			return 'Role is required';
		}
		return '';
	};

	const isInvalidString = (value: string) => {
		return !value || value.trim() === '';
	};

	const validateDuplicatesDontExist = (value: string, existingValues: string[]) => {
		return !existingValues.includes(value);
	};

	const blocker = useBlocker(({ currentLocation, nextLocation }) => {
		const blockedPaths = [
			'/user-management/add-user',
			'/user-management/edit-user',
			'/user-management/confirm-user',
		];

		if (
			blockedPaths.includes(nextLocation.pathname) &&
			blockedPaths.includes(currentLocation.pathname)
		) {
			return false;
		}

		if (blockedPaths.includes(currentLocation.pathname) && isDirty) {
			setShowDirtyModal(true);
			return true;
		}
		return false;
	});

	const blockerProceed = () => {
		if (blocker && blocker.proceed) {
			setShowDirtyModal(false);
			blocker.proceed();
		}
	};

	return {
		isDirty,
		setIsDirty,
		showDirtyModal,
		setShowDirtyModal,
		blockerProceed,
		validate: {
			validateFirstName,
			validateLastName,
			validateEmail,
			validatePhoneNumber,
			validateAccountId,
			validateRoleId,
			isInvalidString,
		},
		addUserStates: {
			isSubmitting,
			setIsSubmitting,
			showSuccessModal,
			setShowSuccessModal,
		},
	};
};
export default useFormHook;
